import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "rse-block-card border p-3 d-flex flex-column" }
const _hoisted_2 = { class: "d-flex align-items-center gap-3" }
const _hoisted_3 = {
  class: "rse-image-wrapper justify-content-center d-flex",
  style: {"min-width":"95px"}
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "rse-block-text-area d-flex flex-column gap-1 flex-grow-1" }
const _hoisted_6 = { class: "rse-block-text body" }
const _hoisted_7 = {
  style: {"color":"var(--primary-blue)"},
  width: "10",
  height: "10"
}

import { ref } from 'vue';
import { RSE_LINKS } from '@/vue/responsible-stay/config/index';

// Define interface for the props
interface IRSECard {
  title: string;
  description: string;
  icon: string;
  linkKey: string;
}

// Props

export default /*@__PURE__*/_defineComponent({
  __name: 'RSEcard',
  props: {
    title: {},
    description: {},
    icon: {},
    linkKey: {}
  },
  setup(__props: any) {

const props = __props;

// Refs
const content = ref<{ [key: string]: string }>(window.content);

// Function to open the correct link in a new tab
const openLink = () => {
  const url = RSE_LINKS[props.linkKey];
  if (url) {
    window.open(url, '_blank');
  } else {
    console.warn('No link found for key:', props.linkKey);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            src: _ctx.icon,
            alt: "icon"
          }, null, 8, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.description), 1),
          _createElementVNode("div", {
            class: "link-large-underline link-default read-more cursor-pointer align-self-end",
            onClick: openLink
          }, [
            _createElementVNode("span", null, _toDisplayString(content.value.planner_prestationsMoreInfo), 1),
            _createElementVNode("span", null, [
              (_openBlock(), _createElementBlock("svg", _hoisted_7, _cache[0] || (_cache[0] = [
                _createElementVNode("use", { "xlink:href": "#___icon___chevron-right-bold" }, null, -1)
              ])))
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})